import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleLayout } from "./components/RoleLayout";
import { Button, Spinner } from "./components/ui";
import { useAuth } from "./hooks/useAuth";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { FeedPage } from "./pages/FeedPage";
import { ActivityDetailPage } from "./pages/ActivityDetailPage";
import { ActivityFormPage } from "./pages/ActivityFormPage";
import { ValidationQueuePage } from "./pages/ValidationQueuePage";
import { ReportsPage } from "./pages/ReportsPage";
import { ProfilePage } from "./pages/ProfilePage";
import { UserManagementPage } from "./pages/UserManagementPage";
import { RegisterPage } from "./pages/RegisterPage";

/** Penjaga rute: menunggu sesi selesai dimuat sebelum memutuskan. */
function RequireAuth() {
  const { isAuthed, isLoading } = useAuth();

  if (isLoading) return <Spinner label="Memeriksa sesi..." />;
  if (!isAuthed) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function NotFoundPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 px-4 text-center">
      <h1 className="text-2xl font-bold text-slate-900">Halaman tidak ditemukan</h1>
      <p className="text-sm text-slate-600">
        Periksa kembali tautan yang Anda buka atau kembali ke dasbor.
      </p>
      <a href="/">
        <Button>Kembali ke dasbor</Button>
      </a>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<RoleLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="kegiatan" element={<FeedPage />} />
          <Route path="kegiatan/baru" element={<ActivityFormPage />} />
          <Route path="kegiatan/:id" element={<ActivityDetailPage />} />
          <Route path="kegiatan/:id/ubah" element={<ActivityFormPage />} />
          <Route path="validasi" element={<ValidationQueuePage />} />
          <Route path="laporan" element={<ReportsPage />} />
          <Route path="pengguna" element={<UserManagementPage />} />
          <Route path="profil" element={<ProfilePage />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
